"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPromise = isPromise;

function isPromise(value) {
  return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}